import { PATH } from 'constants/RoutesConstants';

export const CHECKLIST_DETAILED_PATHS = [
  PATH.GROUP_EXTRA_DETAILED,
  PATH.GROUP_OFFERS_DETAILED,
  PATH.GROUP_CHECKLISTS_DETAILED,
  PATH.GROUP_PARTS_OFFERS_DETAILS,
  PATH.OFFERS_DETAILED,
  PATH.CHECKLISTS_DETAILED,
  PATH.PARTS_OFFERS_DETAILS,
  PATH.DEALER_EXTRA_DETAILED,
];
